import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ReactElement } from 'react'
import { Google, MetaBrand, Shopify, TikTokBrand, TwitterBrand, YouTubeBrand } from 'blaze-ui/icons'
import { InstagramBrand } from 'blaze-ui/icons/24'
import MailchimpBrand from 'blaze-ui/icons/35/MailchimpBrand'
import { FacebookBrand, WordPressBrand } from 'blaze-ui/icons/35'
import { LinkedInBrand } from 'blaze-ui/icons/32'
import { InstagramReelsBrand } from 'blaze-ui/icons/30'
import { ZapierLogo } from 'almanac-ui/icons/24'

export const PlatformIcon = ({
  platform,
  size,
  isSelected,
  isBrand,
  isReels,
}: {
  platform: ExternalIntegrationEnum
  size?: number
  isSelected?: boolean
  isBrand?: boolean
  isReels?: boolean
}): ReactElement | null => {
  switch (platform) {
    case ExternalIntegrationEnum.LinkedIn:
      if (isBrand) return <LinkedInBrand size={size} />

      return <ChannelIcon channel={ChannelType.LinkedInPosts} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.Instagram:
      if (isReels) return <InstagramReelsBrand size={size} />
      if (isBrand) return <InstagramBrand size={size} />

      return <ChannelIcon channel={ChannelType.InstagramPosts} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.X:
      if (isBrand) return <TwitterBrand size={size} />

      return <ChannelIcon channel={ChannelType.Tweets} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.Facebook:
      if (isBrand) return <FacebookBrand size={size} />

      return <ChannelIcon channel={ChannelType.FacebookPost} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.WordPress:
      return <WordPressBrand size={size} />
    case ExternalIntegrationEnum.Shopify:
      return <Shopify size={size} />
    case ExternalIntegrationEnum.TikTok:
      if (isBrand) return <TikTokBrand size={size} />

      return <ChannelIcon channel={DesignChannel.TikTokPost} size={size} />
    case ExternalIntegrationEnum.Google:
      return <Google size={size} />
    case ExternalIntegrationEnum.GoogleBusinessProfile:
      return <Google size={size} />
    case ExternalIntegrationEnum.YouTube:
      if (isBrand) return <YouTubeBrand size={size} />
      return <ChannelIcon channel={DesignChannel.YoutubeShort} size={size} />
    case ExternalIntegrationEnum.Mailchimp:
      return <MailchimpBrand size={size} />
    case ExternalIntegrationEnum.MetaAds:
      return <MetaBrand size={size} />
    case ExternalIntegrationEnum.Zapier:
      return <ZapierLogo size={size} />
    default:
      return null
  }
}
